import {omit} from 'lodash';
import {portfolioUrl} from 'shared/portfolio/utils';
import req, {rejectCamelizedErrors, rejectGenericError} from 'shared/req';
import {objectId} from 'shared/utils';
import {RECEIVE_INSTITUTION} from 'portfolio/actions/institution';

export const NEW_COLLEGE_COURSE = 'NEW_COLLEGE_COURSE';
export const SAVE_COLLEGE_COURSE = 'SAVE_COLLEGE_COURSE';
export const EDIT_COLLEGE_COURSE = 'EDIT_COLLEGE_COURSE';
export const CANCEL_EDIT_COLLEGE_COURSE = 'CANCEL_EDIT_COLLEGE_COURSE';
export const COLLEGE_COURSE_DELETED = 'COLLEGE_COURSE_DELETED';
export const SCROLL_TO_COLLEGE_COURSE = 'SCROLL_TO_COLLEGE_COURSE';
export const SCROLLED_TO_COLLEGE_COURSE = 'SCROLLED_TO_COLLEGE_COURSE';
export const RECEIVE_COLLEGE_COURSES = 'RECEIVE_COLLEGE_COURSES';

export const newCollegeCourseObject = (institution = {}) => ({
  _id: objectId(),
  year: new Date().getFullYear(),
  semester: '',
  courseCode: '',
  name: '',
  subject: '',
  creditHours: null,
  grade: {
    gradeInput: '',
    gradeType: institution.gradeSettings.gradeType || 'L',
    period: 'F',
  },
  institution: {
    name: institution.name,
    parentId: institution.parentId,
    type: institution.type,
    _id: institution._id,
  },
  editing: true,
  new: true,
  scrollTo: true,
});

export function newCollegeCourse(institution) {
  return {
    type: NEW_COLLEGE_COURSE,
    course: newCollegeCourseObject(institution),
  };
}

export function cancelCollegeCourse(course) {
  return {
    type: CANCEL_EDIT_COLLEGE_COURSE,
    course,
  };
}

export function deleteCollegeCourse(id) {
  return (dispatch, getState) => {
    const {
      student: {_id},
    } = getState();
    return req({
      url: portfolioUrl(`/college_courses/${id}`, _id),
      method: 'DELETE',
    }).then(() => {
      dispatch({
        type: COLLEGE_COURSE_DELETED,
        id,
      });
    });
  };
}

export function editCollegeCourse(course) {
  return {
    type: EDIT_COLLEGE_COURSE,
    course,
  };
}

export function scrolledToCollegeCourse(id) {
  return {
    type: SCROLLED_TO_COLLEGE_COURSE,
    id,
  };
}

export function scrollToCollegeCourse(id) {
  return {
    type: SCROLL_TO_COLLEGE_COURSE,
    id,
  };
}

export const saveCollegeCourse = (course) => (dispatch, getState) => {
  let url;
  let method;
  if (course.new) {
    url = '/college_courses';
    method = 'POST';
  } else {
    url = `/college_courses/${course._id}`;
    method = 'PATCH';
  }

  const {
    student: {_id},
  } = getState();
  return req({
    url: portfolioUrl(url, _id),
    method: method,
    data: {
      ...omit(course, ['new', 'grade']),
      grade: {
        ...course.grade,
        gradeInput: course.grade.gradeInput === 'I' ? 'INC' : course.grade.gradeInput,
      },
    },
  })
    .then(({course: courseResponse}) => {
      dispatch({
        type: RECEIVE_COLLEGE_COURSES,
        collegeCourses: [courseResponse],
      });

      dispatch({
        type: RECEIVE_INSTITUTION,
        institution: courseResponse.institution,
      });
    })
    .catch(rejectCamelizedErrors)
    .catch(rejectGenericError);
};
